import CloseIcon from '@mui/icons-material/Close';
import {
    Dialog,
    DialogActions,
    DialogContent,
    IconButton,
} from '@mui/material';
import React from 'react';
import { TitleNormal, TitleNormalBold } from '../common-text';
import { pxToRem } from '../utils/ConvertUtils';
import BTButton from './BTButton';

interface BTDialogProps {
    open: boolean;
    onClose: () => void;
    title?: string;
    message: string;
    confirmButtonTitle?: string;
    cancelButtonTitle?: string;
    icon?: React.ReactNode;
    onConfirm?: () => void;
    onCancel?: () => void;
    isCaution?: boolean;
}

const BTDialog: React.FC<BTDialogProps> = ({
    open,
    onClose,
    title = '',
    message,
    confirmButtonTitle = '확인',
    cancelButtonTitle = '취소',
    onConfirm,
    onCancel,
}) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            PaperProps={{
                style: {
                    width: 400,
                    borderRadius: 12,
                    padding: `${pxToRem(40)} ${pxToRem(40)} ${pxToRem(34)}`,
                    boxSizing: 'border-box',
                    textAlign: 'center',
                },
            }}
        >
            {/* 닫기 버튼 */}
            <IconButton
                onClick={() => 
                    onClose()
                }
                style={{
                    position: 'absolute',
                    right: 12,
                    top: 12,
                    backgroundColor: '#eeeee', // 기본 배경 (연한 회색)
                    borderRadius: '50%',
                    padding: 4,
                    transition: 'background-color 0.2s',
                }}
                onMouseEnter={e => {
                    (e.currentTarget as HTMLButtonElement).style.backgroundColor = 'rgba(0, 0, 0, 0.1)';
                }}
                onMouseLeave={e => {
                    (e.currentTarget as HTMLButtonElement).style.backgroundColor = 'rgba(0, 0, 0, 0.04)';
                }}
            >
                <CloseIcon fontSize="small" />
            </IconButton>

            {/* 제목 */}
            {title && (
                <TitleNormalBold fontSize={22} style={{ marginBottom: 16 }}>
                    {title}
                </TitleNormalBold>
            )}

            {/* 내용 */}
            <DialogContent>
                <TitleNormal style={{ whiteSpace: 'pre-line', fontSize: 18, lineHeight: 1.6 }}>
                    {message}
                </TitleNormal>
            </DialogContent>

            {/* 버튼 */}
            <DialogActions
                style={{ justifyContent: 'center', gap: '12px', marginTop: 24 }}
            >
                {onCancel != undefined &&
                    <BTButton
                        onClick={onCancel}
                        color="#D9D9D9"
                        textColor="white"
                        sx={{ borderRadius: '8px', width: `${pxToRem(130)}` }}
                    >
                        {cancelButtonTitle}
                    </BTButton>
                }

                {onConfirm != undefined &&
                    <BTButton
                        onClick={onConfirm}
                        color="#14B446"
                        textColor="white"
                        sx={{ borderRadius: '8px', width: `${pxToRem(130)}` }}
                    >
                        {confirmButtonTitle}
                    </BTButton>
                }
            </DialogActions>
        </Dialog>
    );
};

export default BTDialog;
